// extracted by mini-css-extract-plugin
module.exports = {"description":"_119280","descriptionLink":"_502247","link":"_4b2fcb"};